import { keepPreviousData, useQuery } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import type { ResponseError } from "app/services/fetchService";

import type { CsvExportLeadsColumnConfigDto } from "../types/columns";

import { enrichmentQueryKeys } from "./key-factory/queryKeyFactory";

export const useCsvEnrichmentColumnConfig = <T = CsvExportLeadsColumnConfigDto>(
    select?: (data: CsvExportLeadsColumnConfigDto) => T,
) => {
    return useQuery<CsvExportLeadsColumnConfigDto, ResponseError, T>({
        queryKey: enrichmentQueryKeys.exportColumnConfig(),
        queryFn({ signal }): Promise<CsvExportLeadsColumnConfigDto> {
            return salesApiService.enrichment.fetchColumnConfig({ cancellation: signal });
        },
        select,
        staleTime: Number.POSITIVE_INFINITY,
        gcTime: Number.POSITIVE_INFINITY,
        placeholderData: keepPreviousData,
        throwOnError: true,
    });
};
